import React from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable, View, ScrollView } from 'react-native';
import Icon from 'LocalGluons/components/Icon';
import Hr from 'LocalGluons/components/Hr';

import defaultStyles from './FilterModal.jss';

export const MODAL_THEME_TYPE = {
    DARK: 'dark',
    LIGHT: 'light'
};

const FilterModal = ({ heading, items, onClose, onChange, style, theme }) => (
    <View
        style={[
            defaultStyles.container,
            theme === MODAL_THEME_TYPE.LIGHT && {
                backgroundColor: 'rgba(255, 255, 255, 0.95)'
            }
        ]}
    >
        <ScrollView contentContainerStyle={style}>
            <View style={defaultStyles.innerContainer}>
                {heading && [
                    <View key="heading" style={defaultStyles.header}>
                        <Text style={defaultStyles.headerHeading}>{heading}</Text>
                        <Icon
                            style={defaultStyles.headerCloseIcon}
                            name="close_grey"
                            onPress={onClose}
                        />
                    </View>,
                    <Hr key="hr" />
                ]}
                {items.map((item) => (
                    <Pressable
                        key={item.label}
                        style={defaultStyles.filterItem}
                        onPress={() => {
                            onChange(item);
                        }}
                    >
                        <Text
                            style={[
                                defaultStyles.filterItemLabel,
                                item.isSelected && defaultStyles.filterItemLabelSelected
                            ]}
                        >
                            {item.label}
                        </Text>
                    </Pressable>
                ))}
            </View>
        </ScrollView>
    </View>
);

FilterModal.defaultProps = {
    heading: null,
    onClose: () => {},
    onChange: () => {},
    style: {},
    theme: MODAL_THEME_TYPE.LIGHT
};

FilterModal.propTypes = {
    heading: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.id,
            label: PropTypes.string,
            isSelected: PropTypes.bool
        })
    ).isRequired,
    onClose: PropTypes.func,
    onChange: PropTypes.func,
    style: PropTypes.shape({}),
    theme: PropTypes.string
};

export default FilterModal;
